import styled, { css } from 'styled-components';

export const BannerRoot = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  justify-content: center;
  background: #fff;
  overflow: visible;

  @media (min-width: 1024px) {
    flex-direction: row;
    align-items: center;
    background: var(--color-surface);
    padding-top: 1rem;
    padding-bottom: 5rem;
  }
`;

export const HeroColumn = styled.div`
  width: 100%;
  padding: 0 1rem;
  margin-top: -210px;
  z-index: 9;
  position: relative;
  flex-shrink: 0;

  @media (min-width: 1024px) {
    width: 350px;
    padding: 0;
    margin-top: 0;
    margin-right: -175px;
  }

  @media (min-width: 1280px) {
    width: 400px;
    margin-right: -200px;
  }

  @media (min-width: 1536px) {
    width: 500px;
    margin-right: -250px;
  }
`;

export const BannerMedia = styled.div`
  width: 100%;
  height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-radius: 0;
  overflow: hidden;
  flex: 0 0 auto;

  .ant-carousel,
  .slick-slider,
  .slick-list,
  .slick-track,
  .slick-slide,
  .slick-slide > div {
    height: 100% !important;
    width: 100%;
  }

  img,
  .banner-slide {
    width: 100%;
    height: 100% !important;
    object-fit: cover;
    display: block;
  }

  /* Dots acima da sobreposição do Hero no mobile */
  .slick-dots {
    z-index: 1;
  }

  @media (max-width: 1023px) {
    .slick-dots {
      bottom: 228px !important;
    }

    .slick-prev,
    .slick-next {
      display: none !important;
    }
  }

  @media (min-width: 1024px) {
    /* Proporção do placeholder do template (1908x1302) nas alturas definidas */
    width: calc(500px * 1908 / 1302);
    max-width: calc(100vw - 2rem);
    border-radius: 1rem;

    img,
    .banner-slide {
      border-radius: 1rem;
    }
  }

  @media (min-width: 1280px) {
    height: 650px;
    width: calc(650px * 1908 / 1302);
  }

  @media (min-width: 1536px) {
    height: 750px;
    width: calc(750px * 1908 / 1302);
  }
`;

export const HeroCard = styled.div<{ $expanded?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background: #fff;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  border-radius: ${({ $expanded }) =>
    $expanded ? '1.5rem 1.5rem 0 0' : '1.5rem'};
  padding: 1rem;
  position: relative;
  overflow: visible;

  @media (min-width: 1280px) {
    padding: 1.5rem;
    gap: 1.25rem;
  }
`;

export const HeroTitle = styled.h4`
  font-size: 1rem;
  font-weight: 700;
  color: var(--color-text);
  line-height: 1.3;

  @media (min-width: 1280px) {
    font-size: 1.25rem;
  }

  @media (min-width: 1536px) {
    font-size: 1.5rem;
  }
`;

export const HeroSubtitle = styled.p`
  font-size: 0.75rem;
  margin-top: 0.25rem;
  color: #555;

  @media (min-width: 1280px) {
    font-size: 0.875rem;
  }

  @media (min-width: 1536px) {
    font-size: 1rem;
  }
`;

export const FieldLabel = styled.label<{ $placeholderLike?: boolean }>`
  width: 100%;
  display: block;
  padding: 0.5rem 2rem;
  color: var(--color-primary);
  font-size: 0.75rem;
  font-weight: 600;
  background: var(--color-hero-input);
  border-radius: 2rem;
  transition: box-shadow 0.3s ease;

  &:focus-within {
    box-shadow: 0 0 0 1px var(--color-primary);
  }

  @media (min-width: 1280px) {
    font-size: 0.875rem;
  }

  @media (min-width: 1536px) {
    font-size: 1rem;
  }

  input,
  select {
    width: 100%;
    color: var(--color-primary);
    font-size: 0.75rem;
    font-weight: 500;
    background: transparent;
    border: none;
    outline: none;
    font-family: 'Montserrat', sans-serif;

    &::placeholder {
      color: rgba(14, 34, 68, 0.45);
      opacity: 1;
    }

    @media (min-width: 1280px) {
      font-size: 0.875rem;
    }
  }

  select {
    ${({ $placeholderLike }) =>
      $placeholderLike &&
      css`
        color: rgba(14, 34, 68, 0.45);
        font-weight: 400;
      `}

    option {
      color: var(--color-primary);
      font-weight: 500;
    }

    option[value=''] {
      color: rgba(14, 34, 68, 0.45);
    }
  }
`;

export const FieldsRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;

  ${FieldLabel} {
    width: 48%;
  }
`;

export const SearchButton = styled.button`
  width: 100%;
  height: 48px;
  color: #fff;
  font-size: 0.75rem;
  font-weight: 600;
  background: var(--color-primary);
  border: none;
  border-radius: 2rem;
  font-family: 'Montserrat', sans-serif;
  cursor: pointer;
  transition: background 0.3s ease;

  &:hover {
    background: var(--color-secondary);
  }

  @media (min-width: 1280px) {
    height: 52px;
    font-size: 0.875rem;
  }
`;

export const MoreFiltersToggle = styled.button`
  border: none;
  background: transparent;
  color: var(--color-primary);
  font-size: 0.75rem;
  font-weight: 500;
  text-align: center;
  text-decoration: underline;
  cursor: pointer;
  font-family: 'Montserrat', sans-serif;
  transition: color 0.3s ease;

  &:hover {
    color: var(--color-secondary);
  }

  @media (min-width: 1280px) {
    font-size: 0.875rem;
  }
`;

export const ExpandedFilters = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  z-index: 20;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: min(60vh, 520px);
  background: #fff;
  border-radius: 0 0 1.5rem 1.5rem;
  box-shadow: 0 18px 32px rgba(0, 0, 0, 0.14);
  overflow: hidden;

  .field-block {
    margin-bottom: 0.85rem !important;
  }
`;

export const ExpandedFiltersBody = styled.div`
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 0.75rem 1rem 0.25rem;

  @media (min-width: 1280px) {
    padding: 0.75rem 1.5rem 0.25rem;
  }
`;

export const ExpandedFiltersFooter = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.75rem 1rem 1rem;
  background: #fff;
  border-top: 1px solid rgba(14, 34, 68, 0.08);
  box-shadow: 0 -8px 16px rgba(14, 34, 68, 0.04);

  @media (min-width: 1280px) {
    padding: 0.75rem 1.5rem 1.25rem;
  }
`;

export const ClearFiltersButton = styled.button`
  border: none;
  background: transparent;
  color: var(--color-primary);
  font-size: 0.75rem;
  font-weight: 500;
  text-align: center;
  text-decoration: underline;
  cursor: pointer;
  font-family: 'Montserrat', sans-serif;
  transition: color 0.3s ease;

  &:hover {
    color: var(--color-secondary);
  }

  @media (min-width: 1280px) {
    font-size: 0.875rem;
  }
`;
